import { useState, useEffect, useCallback } from 'react';
import { logger } from '../../utils/logger';
import { getCsrfTokenFromCookies } from '../csrf';

const useAuthTokens = () => {
  const getCurrentCsrfToken = () => getCsrfTokenFromCookies().csrfToken;
  const [accessToken, setAccessToken] = useState(() =>
    localStorage.getItem('accessToken')
  );
  logger.log('accessToken', accessToken);
  const [csrfToken, setCsrfTokenState] = useState(getCurrentCsrfToken);
  // Set tokens in both state and localStorage
  const setTokens = useCallback((tokens) => {
    if (tokens?.accessToken) {
      localStorage.setItem('accessToken', tokens.accessToken);
      setAccessToken(tokens.accessToken);
    }
  }, []);
  const refreshCsrfToken = () => {
    setCsrfTokenState(getCurrentCsrfToken());
  };

  // Fetch tokens from localStorage
  // const getTokens = useCallback(
  //   () => ({
  //     accessToken: localStorage.getItem('accessToken'),
  //     csrfToken: localStorage.getItem('csrfToken'),
  //   }),
  //   []
  // );

  // Clear tokens from both state and localStorage
  const clearTokens = useCallback(() => {
    localStorage.removeItem('accessToken');
    setAccessToken(null);
    setCsrfTokenState(null);
  }, []);

  return { accessToken, csrfToken, setTokens, clearTokens, refreshCsrfToken };
};

export default useAuthTokens;
